import { Component, Injector, inject as inject_1, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule,JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from "jk-advcom";
import { UtysbService, templateUrlConfigUty } from '../_service_uty';
import { Utysb } from '../_entity_uty';


@Component({
  selector: 'app-utysb-edit',
  templateUrl: './utysb-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [JackBaseComponentModule, AdvComModule,MaterialModule],
})

export class UtysbEditComponent extends JkDialogEditComponent<UtysbService,Utysb>{
  override dialogRef: MatDialogRef<UtysbEditComponent>;
  override data: jkRestReturn;

  override srv!: UtysbService;
  constructor() {
    const inject = inject_1(Injector);
    const dialogRef = inject_1<MatDialogRef<UtysbEditComponent>>(MatDialogRef);
    const data = inject_1<jkRestReturn>(MAT_DIALOG_DATA);

    super(inject,dialogRef,data);

    this.dialogRef = dialogRef;
    this.data = data;
  }


}
